
































import VueOptions from '@utils/VueOptions'

settings =
  name: 'AudienceListingPOILocations'

  vue:
    props: ['poi']

    data: ->
      showAll: false

    methods:
      addressForLocation: (location) -> location.full_address || location.address


export default VueOptions.vue settings
